<template lang="pug">
div
  el-row(:span="24")
    el-col(:span="12")
      app-display(
        v-if="!isBahia && !isProcessoFisico"
        label="Possui CAR?",
        :content="imovel.possuiCar || ((isAmapa || isPara) && isOneroso) ? 'Sim' : 'Não'",
        :class = "compararImovel && compararImovel.mudouPossuiCar ? 'text': '' "
      )
    el-col(:span="12", v-if="imovel.possuiConflitoAgrario !== null && !isBahia && !isPara && !isProcessoFisico && !isAmapa")
      app-display(
        label="Possui conflito fundiário?",
        :content="imovel.possuiConflitoAgrario ? 'Sim' : 'Não'",
        :class = "compararImovel && compararImovel.mudouConflitos ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        :label="labelImovel.numeroRecibo",
        :content="quebraLinha(imovel.numeroReciboCar)",
        :isContentInNextLine="true"
        v-if="imovel.numeroReciboCar",
        :marginBottom="true",
        :class = "compararImovel && compararImovel.mudouNumeroReciboCar ? 'text': '' "
      )
    el-col(:span="12", v-if="imovel.descricao")
      app-display(
        label="Descrição:",
        :content="imovel.descricao",
      )
    el-col(:span="12", v-if="isBahia")
      app-display(
        label="Comunidade:",
        :content="imovel.comunidade || '-'",
      )
    el-col(:span="12", v-if="isProcessoFisico")
      app-display(
        label="Denominação do Imóvel:",
        :content="imovel.denominacao || '-'",
      )
    el-col(:span="12", v-if="isProcessoFisico")
      app-display(
        label="Gleba:",
        :content="imovel.gleba || '-'",
      )
    el-col(:span="12", v-if="showNomeNucleo")
      app-display(
        label="Nome do núcleo:",
        :content="imovel.nomeNucleo || '-'",
      )
    el-col(:span="12", v-if="isProcessoFisico")
      app-display(
        label="Localização:",
        :content="imovel.localizacao || '-'",
      )
    el-col(:span="12", v-if="isProcessoFisico")
      app-display(
        label="Latitude:",
        :content="imovel.latitude || '-'",
      )
    el-col(:span="12", v-if="isProcessoFisico")
      app-display(
        label="UF localização da sede:",
        :content="imovel.ufLocalizacaoSede || 'MA'",
      )
    el-col(:span="12", v-if="isProcessoFisico")
      app-display(
        label="Longitude:",
        :content="imovel.longitude || '-'",
      )
    el-col(:span="12", v-if="isProcessoFisico")
      app-display(
        label="Logradouro:",
        :content="imovel.logradouro || '-'",
      )
    el-col(:span="12", v-if="isProcessoFisico")
      app-display(
        :label="!isProcessoFisico ? 'Bairro:': 'Bairro/Localização:'",
        :content="imovel.bairro || '-'",
      )
    el-col(:span="12", v-if="isProcessoFisico")
      app-display(
        label="Número:",
        :content="imovel.numero || '-'",
      )
    el-col(:span="12")
      app-display(
        label="Nome do Imóvel:",
        :content="imovel.nome",
        v-if="imovel.nome"
        :class = "compararImovel && compararImovel.mudouNome ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        v-if="isBahia"
        label="Código do Imóvel:",
        :content="imovel.codigoImovel || '-'",
        :class = "compararImovel && compararImovel.mudouNome ? 'text': '' "
    )
    el-col(:span="12")
      app-display(
        label="Município:",
        :content="imovel.municipio.nome || '-'",
        v-if="hasMunicipio && (!isMaranhao() || isProcessoFisico)"
        :class = "compararImovel && compararImovel.mudouMunicipio ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        label="UF:",
        :content="imovel.municipio.estado || '-'",
        v-if="hasMunicipio && !isMaranhao()"
        :class = "compararImovel && compararImovel.mudouEstadoImovel ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        label="Área:",
        v-if="imovel.area && !isProcessoFisico"
        :content="formatterDecimal(imovel.area) + ' hectare(s)'",
        :class = "compararImovel && compararImovel.mudouArea ? 'text': '' "
      )
      app-display(
        label="Área:",
        v-if="isProcessoFisico"
        :content="formatterDecimal(imovel.area) + ' ' + getTipoArea(imovel.tipoArea)",
        :class = "compararImovel && compararImovel.mudouArea ? 'text': '' "
      )

    el-col(:span="12")
      app-display(
        label="Finalidades:",
        :content="getFinalidades(imovel.finalidades)",
        v-if="imovel.finalidades && imovel.finalidades.length > 0"
        :class = "compararImovel && compararImovel.mudouFinalidadesImovel ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        label="Descrição de acesso:",
        :content="imovel.descricaoAcesso",
        v-if="imovel.descricaoAcesso"
        :class = "compararImovel && compararImovel.mudouDescricaoAcesso ? 'text': '' "
      )
      el-col(:span="12", v-if="((imovel.possuiImovel && !imovel.possuiCar) && !isOnerosoGroup) && !isBahia")
        app-display(
          label="Possui outros imóveis rurais em território nacional?",
          :content="imovel.possuiImovel ? 'Sim' : 'Não'",
          v-if="imovel.possuiImovel !== null"
          :class = "compararImovel && compararImovel.mudouPossuiImovel ? 'text': '' "
        )
      el-col(:span="12", v-if="isAmapa")
        app-display(
          label="Possui outros imóveis rurais em território nacional?",
          :content="imovel.possuiImoveisTerritorioNacional ? 'Sim' : 'Não'",
          v-if="imovel.possuiImoveisTerritorioNacional !== null"
          :class = "compararImovel && compararImovel.mudouPossuiImovel ? 'text': '' "
        )
    el-col(:span="12", v-if="((imovel.ocupantesAnteriores && !imovel.possuiCar) || isOnerosoGroup) && !isBahia")
      app-display(
        label="Há ocupantes anteriores?",
        :content="imovel.ocupantesAnteriores ? 'Sim' : 'Não'",
        v-if="imovel.ocupantesAnteriores !== null"
        :class = "compararImovel && compararImovel.mudouOcupantesAnteriores ? 'text': '' "
      )

    div(v-if="(imovel.ocupantesAnteriores && !imovel.possuiCar) || isOnerosoGroup")
      el-col(v-if="isOneroso && !isAmapa", :span="12")
        app-display(
          :label="labelImovel.possuiImovel",
          :content="imovel.possuiImovel ? 'Sim' : 'Não'",
          v-if="imovel.possuiImovel != null",
          :class = "compararImovel && compararImovel.mudouPossuiImovel ? 'text': '' "
        )

      div(v-if="((imovel.ocupantesAnteriores && !imovel.possuiCar) || isOnerosoGroup) && !isBahia")
        el-col(:span="12")
          app-display(
            label="Há conflitos no imóvel?",
            :content="imovel.conflitos ? 'Sim' : 'Não'",
            v-if="imovel.conflitos != null"
            :class = "compararImovel && compararImovel.mudouConflitos ? 'text': '' "
          )
        el-col(:span="12")
          app-display(
            label="Número do processo judicial:",
            :content="imovel.numeroProcessoJudicial",
            v-if="imovel.numeroProcessoJudicial"
            :class = "compararImovel && compararImovel.mudouNumeroProcessoJudicial ? 'text': '' "
          )
        el-col(:span="12")
          app-display(
            label="Tempo de ocupação:",
            :content="imovel.nomeTempoOcupacao",
            v-if="imovel.nomeTempoOcupacao != null"
          )
        el-col(:span="12")
          app-display(
            label="Tempo de ocupação:",
            :content="getUnidadeAno(imovel.tempoOcupacao)",
            v-if="imovel.tempoOcupacao != null"
            :class = "compararImovel && compararImovel.mudouTempoOcupacao ? 'text': '' "
          )
  div(v-if="isBahia")
    el-col(:span="12")
      app-display(
        v-if="imovel.idTipoOcupacao"
        label="Tipo de ocupação:",
        :content="imovel.idTipoOcupacao === '3' ? imovel.outroTipoOcupacao : imovel.tipoOcupacao.label",
      )
    el-col(:span="12")
      app-display(
        label="Data de ocupação:",
        :content="formataDataHora(imovel.dataOcupacao)",
      )
    el-col(:span="12")
      app-display(
        label="Possui outra propriedade rural?",
        :content="imovel.possuiOutraPropriedadeRural ? 'Sim' : 'Não'",
      )
    informacoes-atividades(
      :destinacaoUsoImovel="destinacaoUsoImovel",
      :compararDestinacaoUsoImovel="compararDestinacaoUsoImovel"
    )
  app-divider(label="Endereço do imóvel" v-if="imovel.endereco")
    informacoes-endereco.margin-top(:endereco="enderecoImovel", slot="body", :mudouEndereco ="false")

  app-collapse(
    title="Matrícula"
    v-if="cadastroOriginal.tipo === 'CERTIDAO_TITULO'",
  )
    el-row
      el-col(:span="12", v-if="imovel.cnsMatricula")
        app-display(
          label="CNS:",
          :content="imovel.cnsMatricula"
          :class = "compararImovel && compararImovel.mudouCNSMatricula ? 'text': '' "
        )
      el-col(:span="12" v-if="imovel.numeroMatricula")
        app-display(
          label="Número:",
          :content="imovel.numeroMatricula"
          :class = "compararImovel && compararImovel.mudouNumeroMatricula ? 'text': '' "
        )
      el-col(:span="12" v-if="imovel.livroMatricula")
        app-display(
          label="Livro:",
          :content="imovel.livroMatricula"
          :class = "compararImovel && compararImovel.mudouLivroMatricula ? 'text': '' "
        )
      el-col(:span="12"  v-if="imovel.numeroFolhaMatricula")
        app-display(
          label="N° da folha:",
          :content="imovel.numeroFolhaMatricula"
          :class = "compararImovel && compararImovel.mudouNumeroFolhaMatricula ? 'text': '' "
        )

  app-collapse(
    title="Dados do Título"
    v-if="cadastroOriginal.tipo === 'CERTIDAO_TITULO'",
  )
    el-row
      el-col(:span="12")
        app-display(
          label="Nome do beneficiário:",
          :content="imovel.nomeBeneficiarioTitulo"
          :class = "compararImovel && compararImovel.mudouNumeroFolhaMatricula ? 'text': '' "
        )
        app-display(
          label="N° do título:",
          :content="imovel.numeroTitulo"
          :class = "compararImovel && compararImovel.mudouNomeBeneficiarioTitulo ? 'text': '' "
        )
        app-display(
          label="Área:",
          :content="formatterDecimal(imovel.areaTitulo) + ' hectare(s)'"
          :class = "compararImovel && compararImovel.mudouAreaTitulo ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          label="Data de expedição:",
          :content="getDate(imovel.dataExpedicaoTitulo)"
          :class = "compararImovel && compararImovel.mudouDataExpedicaoTitulo ? 'text': '' "
        )
        app-display(
          label="Modalidade:",
          :content="formatModalidade(imovel.modalidadeTitulo)"
          :class = "compararImovel && compararImovel.mudouModalidadeTitulo ? 'text': '' "
        )

</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import InformacoesEndereco from './InformacoesEndereco'
import InformacoesAtividades from './InformacoesAtividades'
import moment from 'moment'
import utils from '@/utils/utils'
import { mapState } from 'vuex'
import compararReticacoesDefault from '../../utils/pa/compararReticacoesDefault'
const { labelVisualizacaoProcesso, tiposProcessoFisico } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { tiposArea } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasCentral').default

export default {

  components: {
    AppDisplay,
    AppCollapse,
    InformacoesEndereco,
    InformacoesAtividades
  },

  props: {
    cadastroOriginal: {
      type: Object,
      required: true
    },
    isOneroso: {
      type: Boolean,
      default: false,
      required: false
    },
    isOnerosoGroup: {
      type: Boolean,
      default: false,
      required: false
    },
    compararImovel: {
      type: Object,
      default: compararReticacoesDefault.mudouImovelDTODefault
    },
    destinacaoUsoImovel: {
      type: Object,
      required: false
    },
    compararDestinacaoUsoImovel: {
      type: Object,
      default: compararReticacoesDefault.mudouDestinacaoUsoImovelDTODefault
    }
  },

  methods: {
    getUnidadeAno (ano) {
      if (!ano) return '-'
      return ano <= 1 ? ano + ' ano' : ano + ' anos'
    },
    getDate (date) {
      return moment(new Date(date)).format('DD/MM/YYYY')
    },
    formatterDecimal (value) {
      return utils.format(value, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
    },
    getFinalidades (finalidades) {
      return finalidades.reduce((val, item, index) => {
        if ((index + 1) !== finalidades.length) {
          val += this.formatFinalidade(item) + ', '
        } else {
          val += this.formatFinalidade(item)
        }
        return val
      }, '')
    },
    formatFinalidade (finalidade) {
      switch (finalidade) {
        case 'ABERTURA_MATRICULA':
          return 'Abertura de Matrícula'
        case 'FINANCIAMENTO_BANCARIO':
          return 'Financiamento Bancário'
        case 'LICENCIAMENTO_AMBIENTAL':
          return 'Licenciamento Ambiental'
        case 'MANEJO_FLORESTAL':
          return 'Manejo Florestal'
        case 'REQUALIFICACAO_DESBLOQUEIO':
          return 'Requalificação/Desbloqueio'
        case 'OUTROS':
          return 'Outros'
        default:
          return ''
      }
    },
    formatModalidade (modalidade) {
      switch (modalidade) {
        case 'CARTA_SESMARIAS':
          return 'Carta de Sesmarias'
        case 'POSSE':
          return 'Posse'
        case 'TITULO_DEFINITIVO_DOACAO':
          return 'Título definitivo de doação sob condições resolutivas (Não Onerosa)'
        case 'TITULO_DEFINITIVO_LOTE':
          return 'Título definitivo de lote colonial'
        case 'TITULO_LEGITIMACAO':
          return 'Título de legitimação de posse'
        case 'TITULO_PROPRIEDADE':
          return 'Título de propriedade sob condições resolutivas (Onerosa)'
        case 'OUTROS':
          return 'Outros'
        default:
          return '-'
      }
    },
    quebraLinha (text) {
      let metade = text.substring(text.length / 2)
      return text.replace(metade, '<br/>' + metade)
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    formataDataHora (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    getTipoArea (tipoArea) {
      let tipoAreaObj = tiposArea.find(item => item.codigo === tipoArea)
      return tipoAreaObj?.nome || 'hectare(s)'
    }
  },
  computed: {
    ...mapState({
      ESTADO: state => state.userInterface.dadosEstado.ESTADO
    }),

    hasMunicipio () {
      return this.imovel.municipio && (typeof this.imovel.municipio === 'string' || this.imovel.municipio.id)
    },

    imovel () {
      return this.cadastroOriginal.imovel
    },
    enderecoImovel () {
      return this.imovel.endereco ? this.imovel.endereco : {}
    },
    isProcessoFisico () {
      return this.tiposProcessoFisico.includes(this.cadastroOriginal.tipo)
    },
    isPara () {
      return process.env.ESTADO === 'pa'
    },
    showNomeNucleo () {
      return this.isMaranhao() && !this.isProcessoFisico && !this.isOnerosoGroup
    }
  },
  data () {
    return {
      labelImovel: labelVisualizacaoProcesso.etapaImovel,
      isBahia: process.env.ESTADO === 'ba',
      isAmapa: process.env.ESTADO === 'ap',
      tiposProcessoFisico
    }
  }
}
</script>

<style lang="scss" scoped>
  >>> .text .text{
    color: #ff0000 !important;
  }

  @media (max-width: 780px) {

    div {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesImovel.vue